// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: schedule.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { InsightsProto } from "./analysis";
import { Header } from "./metadata";
import { SlackNotificationRequest } from "./slack_notification";

export const protobufPackage = "com.meritic.newton";

/** Type of run status. */
export enum ScheduledJobType {
  INVALID_JOB_TYPE = 0,
  PLAN_EXECUTION = 1,
  QNA_EXECUTION = 2,
  ANALYST_JOB = 3,
  SCENARIO_JOB = 4,
  UNRECOGNIZED = -1,
}

export function scheduledJobTypeFromJSON(object: any): ScheduledJobType {
  switch (object) {
    case 0:
    case "INVALID_JOB_TYPE":
      return ScheduledJobType.INVALID_JOB_TYPE;
    case 1:
    case "PLAN_EXECUTION":
      return ScheduledJobType.PLAN_EXECUTION;
    case 2:
    case "QNA_EXECUTION":
      return ScheduledJobType.QNA_EXECUTION;
    case 3:
    case "ANALYST_JOB":
      return ScheduledJobType.ANALYST_JOB;
    case 4:
    case "SCENARIO_JOB":
      return ScheduledJobType.SCENARIO_JOB;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScheduledJobType.UNRECOGNIZED;
  }
}

export function scheduledJobTypeToJSON(object: ScheduledJobType): string {
  switch (object) {
    case ScheduledJobType.INVALID_JOB_TYPE:
      return "INVALID_JOB_TYPE";
    case ScheduledJobType.PLAN_EXECUTION:
      return "PLAN_EXECUTION";
    case ScheduledJobType.QNA_EXECUTION:
      return "QNA_EXECUTION";
    case ScheduledJobType.ANALYST_JOB:
      return "ANALYST_JOB";
    case ScheduledJobType.SCENARIO_JOB:
      return "SCENARIO_JOB";
    case ScheduledJobType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of run status. */
export enum JobRunStatus {
  /** PENDING - Task not started executing yet. */
  PENDING = 0,
  /** IN_PROGRESS - Task execution in progress. */
  IN_PROGRESS = 1,
  /** SUCCESS - Task execution finished successfully. */
  SUCCESS = 2,
  /** FAILURE - Task execution failed. */
  FAILURE = 3,
  /** PARTIAL_SUCCESS - Task execution partially succeeded and failed at some point. */
  PARTIAL_SUCCESS = 4,
  UNRECOGNIZED = -1,
}

export function jobRunStatusFromJSON(object: any): JobRunStatus {
  switch (object) {
    case 0:
    case "PENDING":
      return JobRunStatus.PENDING;
    case 1:
    case "IN_PROGRESS":
      return JobRunStatus.IN_PROGRESS;
    case 2:
    case "SUCCESS":
      return JobRunStatus.SUCCESS;
    case 3:
    case "FAILURE":
      return JobRunStatus.FAILURE;
    case 4:
    case "PARTIAL_SUCCESS":
      return JobRunStatus.PARTIAL_SUCCESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobRunStatus.UNRECOGNIZED;
  }
}

export function jobRunStatusToJSON(object: JobRunStatus): string {
  switch (object) {
    case JobRunStatus.PENDING:
      return "PENDING";
    case JobRunStatus.IN_PROGRESS:
      return "IN_PROGRESS";
    case JobRunStatus.SUCCESS:
      return "SUCCESS";
    case JobRunStatus.FAILURE:
      return "FAILURE";
    case JobRunStatus.PARTIAL_SUCCESS:
      return "PARTIAL_SUCCESS";
    case JobRunStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Proto representation of scheduled job. */
export interface ScheduledJobProto {
  /** Header containing metadata about the scheduled job. */
  header?:
    | Header
    | undefined;
  /** Cron expression. */
  cron_expr?:
    | string
    | undefined;
  /** Type of job type. */
  type?:
    | ScheduledJobType
    | undefined;
  /** Job runs. */
  job_runs: Header[];
  runs: ScheduledJobRunProto[];
  /** Boolean field to show that schedule is active or not. */
  is_active?:
    | boolean
    | undefined;
  /** Based on type one of the below fields will be set. */
  scheduled_plan?: ScheduledPlanProto | undefined;
  scheduled_agent?: ScheduledAgentProto | undefined;
  scheduled_analyst?: ScheduledAnalystProto | undefined;
  scheduled_analysis?: ScheduledScenarioJobProto | undefined;
}

/** Proto representation of Scheduled plan. */
export interface ScheduledPlanProto {
  /** Analysis plan header. */
  plan_header?: Header | undefined;
}

/** Proto representation of Scheduled agent. */
export interface ScheduledAgentProto {
  /** Agent header. */
  agent_header?: Header | undefined;
}

/**
 * Proto representation of a Scenario Job — combines scenario definition and scheduling
 * into a single self-contained entity.
 */
export interface ScheduledScenarioJobProto {
  /** Condition that triggers the scenario analysis (e.g. "CPL > 40 for any ad"). */
  trigger?:
    | string
    | undefined;
  /** Instructions for how to analyse data against the trigger. */
  analysis_instructions?:
    | string
    | undefined;
  /** Instructions for how to format and report findings. */
  reporting_instructions?:
    | string
    | undefined;
  /** Instructions for loading/using historical context from past runs. */
  historical_instructions?:
    | string
    | undefined;
  /** One-off temporary instructions that override defaults for a single run. */
  temporary_instructions?:
    | string
    | undefined;
  /** Slack notification config (channel, tagged users, title via notification_config.message_title). */
  slack_notification_request?:
    | SlackNotificationRequest
    | undefined;
  /** LLM id. */
  llm_id?: string | undefined;
}

/** Proto representation of Scheduled analyst job. */
export interface ScheduledAnalystProto {
  /** List of scenario UUIDs to execute. */
  scenario_ids: string[];
  /** Slack notification request configuration. */
  slack_notification_request?:
    | SlackNotificationRequest
    | undefined;
  /** Optional instructions for the analyst job. */
  instructions?:
    | string
    | undefined;
  /** Optional temporary instructions for the analyst job (e.g. one-off run overrides). */
  temporary_instructions?: string | undefined;
}

/** Proto representation of scheduled job runs. */
export interface ScheduledJobRunProto {
  /** Header containing metadata about the scheduled job run. */
  header?:
    | Header
    | undefined;
  /** Status of scheduled job run. */
  status?:
    | JobRunStatus
    | undefined;
  /** Run logs. */
  run_logs: string[];
  /** Run type. */
  type?:
    | ScheduledJobType
    | undefined;
  /** Visibility of the job run. */
  visibility?:
    | boolean
    | undefined;
  /** Based on type one of the below fields will be set. */
  plan_run?: PlanRunProto | undefined;
  agent_run?: AgentRunProto | undefined;
  analyst_run?: AnalystRunProto | undefined;
  scenario_run?: ScenarioRunProto | undefined;
}

/** Details for a PLAN_EXECUTION run. */
export interface PlanRunProto {
  /** Analysis tree header. */
  tree_header?:
    | Header
    | undefined;
  /** Plan insights. */
  insights: InsightsProto[];
}

/**
 * IMPORTANT: Field names in these protos must remain backward compatible,
 * as they are persisted as JSON in Newton.
 * Represents the result of a scenario execution.
 */
export interface ScenarioResultProto {
  /** ID of the scenario that was executed. */
  scenario_id?:
    | number
    | undefined;
  /** Status of the scenario execution. */
  status?:
    | ScenarioResultProto_ScenarioStatus
    | undefined;
  /** Findings or results from the scenario execution. */
  findings?:
    | string
    | undefined;
  /** List of trees and corresponding node IDs that were referenced. */
  referenced_tree_nodes: ScenarioResultProto_ReferencedTreeNodes[];
  /** Description of the issue or scenario that was executed. */
  issue?: string | undefined;
}

/** Status of the scenario execution. */
export enum ScenarioResultProto_ScenarioStatus {
  INVALID = 0,
  VALID = 1,
  WARNING = 2,
  ERROR = 3,
  UNRECOGNIZED = -1,
}

export function scenarioResultProto_ScenarioStatusFromJSON(object: any): ScenarioResultProto_ScenarioStatus {
  switch (object) {
    case 0:
    case "INVALID":
      return ScenarioResultProto_ScenarioStatus.INVALID;
    case 1:
    case "VALID":
      return ScenarioResultProto_ScenarioStatus.VALID;
    case 2:
    case "WARNING":
      return ScenarioResultProto_ScenarioStatus.WARNING;
    case 3:
    case "ERROR":
      return ScenarioResultProto_ScenarioStatus.ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScenarioResultProto_ScenarioStatus.UNRECOGNIZED;
  }
}

export function scenarioResultProto_ScenarioStatusToJSON(object: ScenarioResultProto_ScenarioStatus): string {
  switch (object) {
    case ScenarioResultProto_ScenarioStatus.INVALID:
      return "INVALID";
    case ScenarioResultProto_ScenarioStatus.VALID:
      return "VALID";
    case ScenarioResultProto_ScenarioStatus.WARNING:
      return "WARNING";
    case ScenarioResultProto_ScenarioStatus.ERROR:
      return "ERROR";
    case ScenarioResultProto_ScenarioStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Represents a set of node IDs that were referenced within a specific tree. */
export interface ScenarioResultProto_ReferencedTreeNodes {
  /** ID of the tree in which the node IDs were referenced. */
  tree_id?:
    | string
    | undefined;
  /** List of node IDs within the specified tree that were referenced. */
  node_ids: string[];
}

/**
 * Represents the output generated by darwin agents after processing all the
 * scenario results. TISA_SYNTHESIS will synthesise all the results into
 * concise notification. TISA_NOTIFICATION will contextualise it according to
 * the previous results/notifications.
 */
export interface ScenariosProcessingOutput {
  /**
   * True if the notification should be sent, false otherwise.
   * Acts as a silencing mechanism.
   */
  notify?:
    | boolean
    | undefined;
  /** The output string after the processing (that may be sent as notification). */
  output_string?:
    | string
    | undefined;
  /** Tree nodes that were queried by the agent to produce this output. */
  referenced_tree_nodes: ScenarioResultProto_ReferencedTreeNodes[];
}

/** Details for a AGENT_EXECUTION run. */
export interface AgentRunProto {
  /** The generated insights from the agent execution. */
  agent_output?:
    | string
    | undefined;
  /** Contextualized output. */
  contextualized_output?:
    | string
    | undefined;
  /**
   * Headers of the analysis tree (or schema) generated by the plans assigned
   * to the agent.
   */
  tree_headers: Header[];
  /** Results from scenario execution. */
  scenario_results: ScenarioResultProto[];
  /** Result produced by TISA synthesis. */
  synthesis_result?:
    | ScenariosProcessingOutput
    | undefined;
  /** Result produced by TISA contextualisation. */
  contextualisation_result?: ScenariosProcessingOutput | undefined;
}

/**
 * Scenario job run proto — stores only the single analyst chat session that
 * executed the combined scenario analysis and synthesis.
 */
export interface ScenarioRunProto {
  /** Chat session ID for the analyst chat agent that ran the scenario. */
  analyst_chat_session_id?: string | undefined;
}

/** Analyst job run proto. */
export interface AnalystRunProto {
  /** Map of scenario ID to chat session ID. */
  scenario_chat_sessions: AnalystRunProto_ScenarioChatSession[];
  /** Synthesis agent chat session ID. */
  synthesis_session_id?:
    | string
    | undefined;
  /** Contextualization agent chat session ID. */
  contextualization_session_id?:
    | string
    | undefined;
  /** Slack chat session ID. */
  slack_chat_session_id?: string | undefined;
}

export interface AnalystRunProto_ScenarioChatSession {
  scenario_id?: string | undefined;
  session_id?: string | undefined;
}

function createBaseScheduledJobProto(): ScheduledJobProto {
  return {
    header: undefined,
    cron_expr: undefined,
    type: undefined,
    job_runs: [],
    runs: [],
    is_active: undefined,
    scheduled_plan: undefined,
    scheduled_agent: undefined,
    scheduled_analyst: undefined,
    scheduled_analysis: undefined,
  };
}

export const ScheduledJobProto: MessageFns<ScheduledJobProto> = {
  encode(message: ScheduledJobProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.cron_expr !== undefined) {
      writer.uint32(18).string(message.cron_expr);
    }
    if (message.type !== undefined) {
      writer.uint32(24).int32(message.type);
    }
    for (const v of message.job_runs) {
      Header.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.runs) {
      ScheduledJobRunProto.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.is_active !== undefined) {
      writer.uint32(48).bool(message.is_active);
    }
    if (message.scheduled_plan !== undefined) {
      ScheduledPlanProto.encode(message.scheduled_plan, writer.uint32(58).fork()).join();
    }
    if (message.scheduled_agent !== undefined) {
      ScheduledAgentProto.encode(message.scheduled_agent, writer.uint32(66).fork()).join();
    }
    if (message.scheduled_analyst !== undefined) {
      ScheduledAnalystProto.encode(message.scheduled_analyst, writer.uint32(74).fork()).join();
    }
    if (message.scheduled_analysis !== undefined) {
      ScheduledScenarioJobProto.encode(message.scheduled_analysis, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduledJobProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduledJobProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cron_expr = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.job_runs.push(Header.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.runs.push(ScheduledJobRunProto.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.is_active = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.scheduled_plan = ScheduledPlanProto.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.scheduled_agent = ScheduledAgentProto.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.scheduled_analyst = ScheduledAnalystProto.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.scheduled_analysis = ScheduledScenarioJobProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScheduledJobProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      cron_expr: isSet(object.cron_expr) ? globalThis.String(object.cron_expr) : undefined,
      type: isSet(object.type) ? scheduledJobTypeFromJSON(object.type) : undefined,
      job_runs: globalThis.Array.isArray(object?.job_runs) ? object.job_runs.map((e: any) => Header.fromJSON(e)) : [],
      runs: globalThis.Array.isArray(object?.runs) ? object.runs.map((e: any) => ScheduledJobRunProto.fromJSON(e)) : [],
      is_active: isSet(object.is_active) ? globalThis.Boolean(object.is_active) : undefined,
      scheduled_plan: isSet(object.scheduled_plan) ? ScheduledPlanProto.fromJSON(object.scheduled_plan) : undefined,
      scheduled_agent: isSet(object.scheduled_agent) ? ScheduledAgentProto.fromJSON(object.scheduled_agent) : undefined,
      scheduled_analyst: isSet(object.scheduled_analyst)
        ? ScheduledAnalystProto.fromJSON(object.scheduled_analyst)
        : undefined,
      scheduled_analysis: isSet(object.scheduled_analysis)
        ? ScheduledScenarioJobProto.fromJSON(object.scheduled_analysis)
        : undefined,
    };
  },

  toJSON(message: ScheduledJobProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.cron_expr !== undefined) {
      obj.cron_expr = message.cron_expr;
    }
    if (message.type !== undefined) {
      obj.type = scheduledJobTypeToJSON(message.type);
    }
    if (message.job_runs?.length) {
      obj.job_runs = message.job_runs.map((e) => Header.toJSON(e));
    }
    if (message.runs?.length) {
      obj.runs = message.runs.map((e) => ScheduledJobRunProto.toJSON(e));
    }
    if (message.is_active !== undefined) {
      obj.is_active = message.is_active;
    }
    if (message.scheduled_plan !== undefined) {
      obj.scheduled_plan = ScheduledPlanProto.toJSON(message.scheduled_plan);
    }
    if (message.scheduled_agent !== undefined) {
      obj.scheduled_agent = ScheduledAgentProto.toJSON(message.scheduled_agent);
    }
    if (message.scheduled_analyst !== undefined) {
      obj.scheduled_analyst = ScheduledAnalystProto.toJSON(message.scheduled_analyst);
    }
    if (message.scheduled_analysis !== undefined) {
      obj.scheduled_analysis = ScheduledScenarioJobProto.toJSON(message.scheduled_analysis);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduledJobProto>, I>>(base?: I): ScheduledJobProto {
    return ScheduledJobProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduledJobProto>, I>>(object: I): ScheduledJobProto {
    const message = createBaseScheduledJobProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.cron_expr = object.cron_expr ?? undefined;
    message.type = object.type ?? undefined;
    message.job_runs = object.job_runs?.map((e) => Header.fromPartial(e)) || [];
    message.runs = object.runs?.map((e) => ScheduledJobRunProto.fromPartial(e)) || [];
    message.is_active = object.is_active ?? undefined;
    message.scheduled_plan = (object.scheduled_plan !== undefined && object.scheduled_plan !== null)
      ? ScheduledPlanProto.fromPartial(object.scheduled_plan)
      : undefined;
    message.scheduled_agent = (object.scheduled_agent !== undefined && object.scheduled_agent !== null)
      ? ScheduledAgentProto.fromPartial(object.scheduled_agent)
      : undefined;
    message.scheduled_analyst = (object.scheduled_analyst !== undefined && object.scheduled_analyst !== null)
      ? ScheduledAnalystProto.fromPartial(object.scheduled_analyst)
      : undefined;
    message.scheduled_analysis = (object.scheduled_analysis !== undefined && object.scheduled_analysis !== null)
      ? ScheduledScenarioJobProto.fromPartial(object.scheduled_analysis)
      : undefined;
    return message;
  },
};

function createBaseScheduledPlanProto(): ScheduledPlanProto {
  return { plan_header: undefined };
}

export const ScheduledPlanProto: MessageFns<ScheduledPlanProto> = {
  encode(message: ScheduledPlanProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.plan_header !== undefined) {
      Header.encode(message.plan_header, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduledPlanProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduledPlanProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.plan_header = Header.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScheduledPlanProto {
    return { plan_header: isSet(object.plan_header) ? Header.fromJSON(object.plan_header) : undefined };
  },

  toJSON(message: ScheduledPlanProto): unknown {
    const obj: any = {};
    if (message.plan_header !== undefined) {
      obj.plan_header = Header.toJSON(message.plan_header);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduledPlanProto>, I>>(base?: I): ScheduledPlanProto {
    return ScheduledPlanProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduledPlanProto>, I>>(object: I): ScheduledPlanProto {
    const message = createBaseScheduledPlanProto();
    message.plan_header = (object.plan_header !== undefined && object.plan_header !== null)
      ? Header.fromPartial(object.plan_header)
      : undefined;
    return message;
  },
};

function createBaseScheduledAgentProto(): ScheduledAgentProto {
  return { agent_header: undefined };
}

export const ScheduledAgentProto: MessageFns<ScheduledAgentProto> = {
  encode(message: ScheduledAgentProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.agent_header !== undefined) {
      Header.encode(message.agent_header, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduledAgentProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduledAgentProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.agent_header = Header.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScheduledAgentProto {
    return { agent_header: isSet(object.agent_header) ? Header.fromJSON(object.agent_header) : undefined };
  },

  toJSON(message: ScheduledAgentProto): unknown {
    const obj: any = {};
    if (message.agent_header !== undefined) {
      obj.agent_header = Header.toJSON(message.agent_header);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduledAgentProto>, I>>(base?: I): ScheduledAgentProto {
    return ScheduledAgentProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduledAgentProto>, I>>(object: I): ScheduledAgentProto {
    const message = createBaseScheduledAgentProto();
    message.agent_header = (object.agent_header !== undefined && object.agent_header !== null)
      ? Header.fromPartial(object.agent_header)
      : undefined;
    return message;
  },
};

function createBaseScheduledScenarioJobProto(): ScheduledScenarioJobProto {
  return {
    trigger: undefined,
    analysis_instructions: undefined,
    reporting_instructions: undefined,
    historical_instructions: undefined,
    temporary_instructions: undefined,
    slack_notification_request: undefined,
    llm_id: undefined,
  };
}

export const ScheduledScenarioJobProto: MessageFns<ScheduledScenarioJobProto> = {
  encode(message: ScheduledScenarioJobProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.trigger !== undefined) {
      writer.uint32(10).string(message.trigger);
    }
    if (message.analysis_instructions !== undefined) {
      writer.uint32(18).string(message.analysis_instructions);
    }
    if (message.reporting_instructions !== undefined) {
      writer.uint32(26).string(message.reporting_instructions);
    }
    if (message.historical_instructions !== undefined) {
      writer.uint32(34).string(message.historical_instructions);
    }
    if (message.temporary_instructions !== undefined) {
      writer.uint32(42).string(message.temporary_instructions);
    }
    if (message.slack_notification_request !== undefined) {
      SlackNotificationRequest.encode(message.slack_notification_request, writer.uint32(50).fork()).join();
    }
    if (message.llm_id !== undefined) {
      writer.uint32(58).string(message.llm_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduledScenarioJobProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduledScenarioJobProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trigger = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.analysis_instructions = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reporting_instructions = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.historical_instructions = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.temporary_instructions = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.slack_notification_request = SlackNotificationRequest.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.llm_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScheduledScenarioJobProto {
    return {
      trigger: isSet(object.trigger) ? globalThis.String(object.trigger) : undefined,
      analysis_instructions: isSet(object.analysis_instructions)
        ? globalThis.String(object.analysis_instructions)
        : undefined,
      reporting_instructions: isSet(object.reporting_instructions)
        ? globalThis.String(object.reporting_instructions)
        : undefined,
      historical_instructions: isSet(object.historical_instructions)
        ? globalThis.String(object.historical_instructions)
        : undefined,
      temporary_instructions: isSet(object.temporary_instructions)
        ? globalThis.String(object.temporary_instructions)
        : undefined,
      slack_notification_request: isSet(object.slack_notification_request)
        ? SlackNotificationRequest.fromJSON(object.slack_notification_request)
        : undefined,
      llm_id: isSet(object.llm_id) ? globalThis.String(object.llm_id) : undefined,
    };
  },

  toJSON(message: ScheduledScenarioJobProto): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = message.trigger;
    }
    if (message.analysis_instructions !== undefined) {
      obj.analysis_instructions = message.analysis_instructions;
    }
    if (message.reporting_instructions !== undefined) {
      obj.reporting_instructions = message.reporting_instructions;
    }
    if (message.historical_instructions !== undefined) {
      obj.historical_instructions = message.historical_instructions;
    }
    if (message.temporary_instructions !== undefined) {
      obj.temporary_instructions = message.temporary_instructions;
    }
    if (message.slack_notification_request !== undefined) {
      obj.slack_notification_request = SlackNotificationRequest.toJSON(message.slack_notification_request);
    }
    if (message.llm_id !== undefined) {
      obj.llm_id = message.llm_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduledScenarioJobProto>, I>>(base?: I): ScheduledScenarioJobProto {
    return ScheduledScenarioJobProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduledScenarioJobProto>, I>>(object: I): ScheduledScenarioJobProto {
    const message = createBaseScheduledScenarioJobProto();
    message.trigger = object.trigger ?? undefined;
    message.analysis_instructions = object.analysis_instructions ?? undefined;
    message.reporting_instructions = object.reporting_instructions ?? undefined;
    message.historical_instructions = object.historical_instructions ?? undefined;
    message.temporary_instructions = object.temporary_instructions ?? undefined;
    message.slack_notification_request =
      (object.slack_notification_request !== undefined && object.slack_notification_request !== null)
        ? SlackNotificationRequest.fromPartial(object.slack_notification_request)
        : undefined;
    message.llm_id = object.llm_id ?? undefined;
    return message;
  },
};

function createBaseScheduledAnalystProto(): ScheduledAnalystProto {
  return {
    scenario_ids: [],
    slack_notification_request: undefined,
    instructions: undefined,
    temporary_instructions: undefined,
  };
}

export const ScheduledAnalystProto: MessageFns<ScheduledAnalystProto> = {
  encode(message: ScheduledAnalystProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.scenario_ids) {
      writer.uint32(10).string(v!);
    }
    if (message.slack_notification_request !== undefined) {
      SlackNotificationRequest.encode(message.slack_notification_request, writer.uint32(18).fork()).join();
    }
    if (message.instructions !== undefined) {
      writer.uint32(26).string(message.instructions);
    }
    if (message.temporary_instructions !== undefined) {
      writer.uint32(34).string(message.temporary_instructions);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduledAnalystProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduledAnalystProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.scenario_ids.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.slack_notification_request = SlackNotificationRequest.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.instructions = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.temporary_instructions = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScheduledAnalystProto {
    return {
      scenario_ids: globalThis.Array.isArray(object?.scenario_ids)
        ? object.scenario_ids.map((e: any) => globalThis.String(e))
        : [],
      slack_notification_request: isSet(object.slack_notification_request)
        ? SlackNotificationRequest.fromJSON(object.slack_notification_request)
        : undefined,
      instructions: isSet(object.instructions) ? globalThis.String(object.instructions) : undefined,
      temporary_instructions: isSet(object.temporary_instructions)
        ? globalThis.String(object.temporary_instructions)
        : undefined,
    };
  },

  toJSON(message: ScheduledAnalystProto): unknown {
    const obj: any = {};
    if (message.scenario_ids?.length) {
      obj.scenario_ids = message.scenario_ids;
    }
    if (message.slack_notification_request !== undefined) {
      obj.slack_notification_request = SlackNotificationRequest.toJSON(message.slack_notification_request);
    }
    if (message.instructions !== undefined) {
      obj.instructions = message.instructions;
    }
    if (message.temporary_instructions !== undefined) {
      obj.temporary_instructions = message.temporary_instructions;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduledAnalystProto>, I>>(base?: I): ScheduledAnalystProto {
    return ScheduledAnalystProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduledAnalystProto>, I>>(object: I): ScheduledAnalystProto {
    const message = createBaseScheduledAnalystProto();
    message.scenario_ids = object.scenario_ids?.map((e) => e) || [];
    message.slack_notification_request =
      (object.slack_notification_request !== undefined && object.slack_notification_request !== null)
        ? SlackNotificationRequest.fromPartial(object.slack_notification_request)
        : undefined;
    message.instructions = object.instructions ?? undefined;
    message.temporary_instructions = object.temporary_instructions ?? undefined;
    return message;
  },
};

function createBaseScheduledJobRunProto(): ScheduledJobRunProto {
  return {
    header: undefined,
    status: undefined,
    run_logs: [],
    type: undefined,
    visibility: undefined,
    plan_run: undefined,
    agent_run: undefined,
    analyst_run: undefined,
    scenario_run: undefined,
  };
}

export const ScheduledJobRunProto: MessageFns<ScheduledJobRunProto> = {
  encode(message: ScheduledJobRunProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.status !== undefined) {
      writer.uint32(16).int32(message.status);
    }
    for (const v of message.run_logs) {
      writer.uint32(26).string(v!);
    }
    if (message.type !== undefined) {
      writer.uint32(32).int32(message.type);
    }
    if (message.visibility !== undefined) {
      writer.uint32(40).bool(message.visibility);
    }
    if (message.plan_run !== undefined) {
      PlanRunProto.encode(message.plan_run, writer.uint32(50).fork()).join();
    }
    if (message.agent_run !== undefined) {
      AgentRunProto.encode(message.agent_run, writer.uint32(58).fork()).join();
    }
    if (message.analyst_run !== undefined) {
      AnalystRunProto.encode(message.analyst_run, writer.uint32(66).fork()).join();
    }
    if (message.scenario_run !== undefined) {
      ScenarioRunProto.encode(message.scenario_run, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduledJobRunProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduledJobRunProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.run_logs.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.visibility = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.plan_run = PlanRunProto.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.agent_run = AgentRunProto.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.analyst_run = AnalystRunProto.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.scenario_run = ScenarioRunProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScheduledJobRunProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      status: isSet(object.status) ? jobRunStatusFromJSON(object.status) : undefined,
      run_logs: globalThis.Array.isArray(object?.run_logs) ? object.run_logs.map((e: any) => globalThis.String(e)) : [],
      type: isSet(object.type) ? scheduledJobTypeFromJSON(object.type) : undefined,
      visibility: isSet(object.visibility) ? globalThis.Boolean(object.visibility) : undefined,
      plan_run: isSet(object.plan_run) ? PlanRunProto.fromJSON(object.plan_run) : undefined,
      agent_run: isSet(object.agent_run) ? AgentRunProto.fromJSON(object.agent_run) : undefined,
      analyst_run: isSet(object.analyst_run) ? AnalystRunProto.fromJSON(object.analyst_run) : undefined,
      scenario_run: isSet(object.scenario_run) ? ScenarioRunProto.fromJSON(object.scenario_run) : undefined,
    };
  },

  toJSON(message: ScheduledJobRunProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.status !== undefined) {
      obj.status = jobRunStatusToJSON(message.status);
    }
    if (message.run_logs?.length) {
      obj.run_logs = message.run_logs;
    }
    if (message.type !== undefined) {
      obj.type = scheduledJobTypeToJSON(message.type);
    }
    if (message.visibility !== undefined) {
      obj.visibility = message.visibility;
    }
    if (message.plan_run !== undefined) {
      obj.plan_run = PlanRunProto.toJSON(message.plan_run);
    }
    if (message.agent_run !== undefined) {
      obj.agent_run = AgentRunProto.toJSON(message.agent_run);
    }
    if (message.analyst_run !== undefined) {
      obj.analyst_run = AnalystRunProto.toJSON(message.analyst_run);
    }
    if (message.scenario_run !== undefined) {
      obj.scenario_run = ScenarioRunProto.toJSON(message.scenario_run);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduledJobRunProto>, I>>(base?: I): ScheduledJobRunProto {
    return ScheduledJobRunProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduledJobRunProto>, I>>(object: I): ScheduledJobRunProto {
    const message = createBaseScheduledJobRunProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.status = object.status ?? undefined;
    message.run_logs = object.run_logs?.map((e) => e) || [];
    message.type = object.type ?? undefined;
    message.visibility = object.visibility ?? undefined;
    message.plan_run = (object.plan_run !== undefined && object.plan_run !== null)
      ? PlanRunProto.fromPartial(object.plan_run)
      : undefined;
    message.agent_run = (object.agent_run !== undefined && object.agent_run !== null)
      ? AgentRunProto.fromPartial(object.agent_run)
      : undefined;
    message.analyst_run = (object.analyst_run !== undefined && object.analyst_run !== null)
      ? AnalystRunProto.fromPartial(object.analyst_run)
      : undefined;
    message.scenario_run = (object.scenario_run !== undefined && object.scenario_run !== null)
      ? ScenarioRunProto.fromPartial(object.scenario_run)
      : undefined;
    return message;
  },
};

function createBasePlanRunProto(): PlanRunProto {
  return { tree_header: undefined, insights: [] };
}

export const PlanRunProto: MessageFns<PlanRunProto> = {
  encode(message: PlanRunProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tree_header !== undefined) {
      Header.encode(message.tree_header, writer.uint32(10).fork()).join();
    }
    for (const v of message.insights) {
      InsightsProto.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanRunProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanRunProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.insights.push(InsightsProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanRunProto {
    return {
      tree_header: isSet(object.tree_header) ? Header.fromJSON(object.tree_header) : undefined,
      insights: globalThis.Array.isArray(object?.insights)
        ? object.insights.map((e: any) => InsightsProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PlanRunProto): unknown {
    const obj: any = {};
    if (message.tree_header !== undefined) {
      obj.tree_header = Header.toJSON(message.tree_header);
    }
    if (message.insights?.length) {
      obj.insights = message.insights.map((e) => InsightsProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanRunProto>, I>>(base?: I): PlanRunProto {
    return PlanRunProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanRunProto>, I>>(object: I): PlanRunProto {
    const message = createBasePlanRunProto();
    message.tree_header = (object.tree_header !== undefined && object.tree_header !== null)
      ? Header.fromPartial(object.tree_header)
      : undefined;
    message.insights = object.insights?.map((e) => InsightsProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScenarioResultProto(): ScenarioResultProto {
  return {
    scenario_id: undefined,
    status: undefined,
    findings: undefined,
    referenced_tree_nodes: [],
    issue: undefined,
  };
}

export const ScenarioResultProto: MessageFns<ScenarioResultProto> = {
  encode(message: ScenarioResultProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scenario_id !== undefined) {
      writer.uint32(8).int32(message.scenario_id);
    }
    if (message.status !== undefined) {
      writer.uint32(16).int32(message.status);
    }
    if (message.findings !== undefined) {
      writer.uint32(26).string(message.findings);
    }
    for (const v of message.referenced_tree_nodes) {
      ScenarioResultProto_ReferencedTreeNodes.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.issue !== undefined) {
      writer.uint32(42).string(message.issue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenarioResultProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenarioResultProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.scenario_id = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.findings = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.referenced_tree_nodes.push(ScenarioResultProto_ReferencedTreeNodes.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.issue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenarioResultProto {
    return {
      scenario_id: isSet(object.scenario_id) ? globalThis.Number(object.scenario_id) : undefined,
      status: isSet(object.status) ? scenarioResultProto_ScenarioStatusFromJSON(object.status) : undefined,
      findings: isSet(object.findings) ? globalThis.String(object.findings) : undefined,
      referenced_tree_nodes: globalThis.Array.isArray(object?.referenced_tree_nodes)
        ? object.referenced_tree_nodes.map((e: any) => ScenarioResultProto_ReferencedTreeNodes.fromJSON(e))
        : [],
      issue: isSet(object.issue) ? globalThis.String(object.issue) : undefined,
    };
  },

  toJSON(message: ScenarioResultProto): unknown {
    const obj: any = {};
    if (message.scenario_id !== undefined) {
      obj.scenario_id = Math.round(message.scenario_id);
    }
    if (message.status !== undefined) {
      obj.status = scenarioResultProto_ScenarioStatusToJSON(message.status);
    }
    if (message.findings !== undefined) {
      obj.findings = message.findings;
    }
    if (message.referenced_tree_nodes?.length) {
      obj.referenced_tree_nodes = message.referenced_tree_nodes.map((e) =>
        ScenarioResultProto_ReferencedTreeNodes.toJSON(e)
      );
    }
    if (message.issue !== undefined) {
      obj.issue = message.issue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenarioResultProto>, I>>(base?: I): ScenarioResultProto {
    return ScenarioResultProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenarioResultProto>, I>>(object: I): ScenarioResultProto {
    const message = createBaseScenarioResultProto();
    message.scenario_id = object.scenario_id ?? undefined;
    message.status = object.status ?? undefined;
    message.findings = object.findings ?? undefined;
    message.referenced_tree_nodes =
      object.referenced_tree_nodes?.map((e) => ScenarioResultProto_ReferencedTreeNodes.fromPartial(e)) || [];
    message.issue = object.issue ?? undefined;
    return message;
  },
};

function createBaseScenarioResultProto_ReferencedTreeNodes(): ScenarioResultProto_ReferencedTreeNodes {
  return { tree_id: undefined, node_ids: [] };
}

export const ScenarioResultProto_ReferencedTreeNodes: MessageFns<ScenarioResultProto_ReferencedTreeNodes> = {
  encode(message: ScenarioResultProto_ReferencedTreeNodes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tree_id !== undefined) {
      writer.uint32(10).string(message.tree_id);
    }
    for (const v of message.node_ids) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenarioResultProto_ReferencedTreeNodes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenarioResultProto_ReferencedTreeNodes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.node_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenarioResultProto_ReferencedTreeNodes {
    return {
      tree_id: isSet(object.tree_id) ? globalThis.String(object.tree_id) : undefined,
      node_ids: globalThis.Array.isArray(object?.node_ids) ? object.node_ids.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ScenarioResultProto_ReferencedTreeNodes): unknown {
    const obj: any = {};
    if (message.tree_id !== undefined) {
      obj.tree_id = message.tree_id;
    }
    if (message.node_ids?.length) {
      obj.node_ids = message.node_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenarioResultProto_ReferencedTreeNodes>, I>>(
    base?: I,
  ): ScenarioResultProto_ReferencedTreeNodes {
    return ScenarioResultProto_ReferencedTreeNodes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenarioResultProto_ReferencedTreeNodes>, I>>(
    object: I,
  ): ScenarioResultProto_ReferencedTreeNodes {
    const message = createBaseScenarioResultProto_ReferencedTreeNodes();
    message.tree_id = object.tree_id ?? undefined;
    message.node_ids = object.node_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseScenariosProcessingOutput(): ScenariosProcessingOutput {
  return { notify: undefined, output_string: undefined, referenced_tree_nodes: [] };
}

export const ScenariosProcessingOutput: MessageFns<ScenariosProcessingOutput> = {
  encode(message: ScenariosProcessingOutput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.notify !== undefined) {
      writer.uint32(8).bool(message.notify);
    }
    if (message.output_string !== undefined) {
      writer.uint32(18).string(message.output_string);
    }
    for (const v of message.referenced_tree_nodes) {
      ScenarioResultProto_ReferencedTreeNodes.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenariosProcessingOutput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenariosProcessingOutput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.notify = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.output_string = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.referenced_tree_nodes.push(ScenarioResultProto_ReferencedTreeNodes.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenariosProcessingOutput {
    return {
      notify: isSet(object.notify) ? globalThis.Boolean(object.notify) : undefined,
      output_string: isSet(object.output_string) ? globalThis.String(object.output_string) : undefined,
      referenced_tree_nodes: globalThis.Array.isArray(object?.referenced_tree_nodes)
        ? object.referenced_tree_nodes.map((e: any) => ScenarioResultProto_ReferencedTreeNodes.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScenariosProcessingOutput): unknown {
    const obj: any = {};
    if (message.notify !== undefined) {
      obj.notify = message.notify;
    }
    if (message.output_string !== undefined) {
      obj.output_string = message.output_string;
    }
    if (message.referenced_tree_nodes?.length) {
      obj.referenced_tree_nodes = message.referenced_tree_nodes.map((e) =>
        ScenarioResultProto_ReferencedTreeNodes.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenariosProcessingOutput>, I>>(base?: I): ScenariosProcessingOutput {
    return ScenariosProcessingOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenariosProcessingOutput>, I>>(object: I): ScenariosProcessingOutput {
    const message = createBaseScenariosProcessingOutput();
    message.notify = object.notify ?? undefined;
    message.output_string = object.output_string ?? undefined;
    message.referenced_tree_nodes =
      object.referenced_tree_nodes?.map((e) => ScenarioResultProto_ReferencedTreeNodes.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAgentRunProto(): AgentRunProto {
  return {
    agent_output: undefined,
    contextualized_output: undefined,
    tree_headers: [],
    scenario_results: [],
    synthesis_result: undefined,
    contextualisation_result: undefined,
  };
}

export const AgentRunProto: MessageFns<AgentRunProto> = {
  encode(message: AgentRunProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.agent_output !== undefined) {
      writer.uint32(10).string(message.agent_output);
    }
    if (message.contextualized_output !== undefined) {
      writer.uint32(18).string(message.contextualized_output);
    }
    for (const v of message.tree_headers) {
      Header.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.scenario_results) {
      ScenarioResultProto.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.synthesis_result !== undefined) {
      ScenariosProcessingOutput.encode(message.synthesis_result, writer.uint32(42).fork()).join();
    }
    if (message.contextualisation_result !== undefined) {
      ScenariosProcessingOutput.encode(message.contextualisation_result, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentRunProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentRunProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.agent_output = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.contextualized_output = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tree_headers.push(Header.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.scenario_results.push(ScenarioResultProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.synthesis_result = ScenariosProcessingOutput.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.contextualisation_result = ScenariosProcessingOutput.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentRunProto {
    return {
      agent_output: isSet(object.agent_output) ? globalThis.String(object.agent_output) : undefined,
      contextualized_output: isSet(object.contextualized_output)
        ? globalThis.String(object.contextualized_output)
        : undefined,
      tree_headers: globalThis.Array.isArray(object?.tree_headers)
        ? object.tree_headers.map((e: any) => Header.fromJSON(e))
        : [],
      scenario_results: globalThis.Array.isArray(object?.scenario_results)
        ? object.scenario_results.map((e: any) => ScenarioResultProto.fromJSON(e))
        : [],
      synthesis_result: isSet(object.synthesis_result)
        ? ScenariosProcessingOutput.fromJSON(object.synthesis_result)
        : undefined,
      contextualisation_result: isSet(object.contextualisation_result)
        ? ScenariosProcessingOutput.fromJSON(object.contextualisation_result)
        : undefined,
    };
  },

  toJSON(message: AgentRunProto): unknown {
    const obj: any = {};
    if (message.agent_output !== undefined) {
      obj.agent_output = message.agent_output;
    }
    if (message.contextualized_output !== undefined) {
      obj.contextualized_output = message.contextualized_output;
    }
    if (message.tree_headers?.length) {
      obj.tree_headers = message.tree_headers.map((e) => Header.toJSON(e));
    }
    if (message.scenario_results?.length) {
      obj.scenario_results = message.scenario_results.map((e) => ScenarioResultProto.toJSON(e));
    }
    if (message.synthesis_result !== undefined) {
      obj.synthesis_result = ScenariosProcessingOutput.toJSON(message.synthesis_result);
    }
    if (message.contextualisation_result !== undefined) {
      obj.contextualisation_result = ScenariosProcessingOutput.toJSON(message.contextualisation_result);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentRunProto>, I>>(base?: I): AgentRunProto {
    return AgentRunProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentRunProto>, I>>(object: I): AgentRunProto {
    const message = createBaseAgentRunProto();
    message.agent_output = object.agent_output ?? undefined;
    message.contextualized_output = object.contextualized_output ?? undefined;
    message.tree_headers = object.tree_headers?.map((e) => Header.fromPartial(e)) || [];
    message.scenario_results = object.scenario_results?.map((e) => ScenarioResultProto.fromPartial(e)) || [];
    message.synthesis_result = (object.synthesis_result !== undefined && object.synthesis_result !== null)
      ? ScenariosProcessingOutput.fromPartial(object.synthesis_result)
      : undefined;
    message.contextualisation_result =
      (object.contextualisation_result !== undefined && object.contextualisation_result !== null)
        ? ScenariosProcessingOutput.fromPartial(object.contextualisation_result)
        : undefined;
    return message;
  },
};

function createBaseScenarioRunProto(): ScenarioRunProto {
  return { analyst_chat_session_id: undefined };
}

export const ScenarioRunProto: MessageFns<ScenarioRunProto> = {
  encode(message: ScenarioRunProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.analyst_chat_session_id !== undefined) {
      writer.uint32(10).string(message.analyst_chat_session_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenarioRunProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenarioRunProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.analyst_chat_session_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenarioRunProto {
    return {
      analyst_chat_session_id: isSet(object.analyst_chat_session_id)
        ? globalThis.String(object.analyst_chat_session_id)
        : undefined,
    };
  },

  toJSON(message: ScenarioRunProto): unknown {
    const obj: any = {};
    if (message.analyst_chat_session_id !== undefined) {
      obj.analyst_chat_session_id = message.analyst_chat_session_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenarioRunProto>, I>>(base?: I): ScenarioRunProto {
    return ScenarioRunProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenarioRunProto>, I>>(object: I): ScenarioRunProto {
    const message = createBaseScenarioRunProto();
    message.analyst_chat_session_id = object.analyst_chat_session_id ?? undefined;
    return message;
  },
};

function createBaseAnalystRunProto(): AnalystRunProto {
  return {
    scenario_chat_sessions: [],
    synthesis_session_id: undefined,
    contextualization_session_id: undefined,
    slack_chat_session_id: undefined,
  };
}

export const AnalystRunProto: MessageFns<AnalystRunProto> = {
  encode(message: AnalystRunProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.scenario_chat_sessions) {
      AnalystRunProto_ScenarioChatSession.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.synthesis_session_id !== undefined) {
      writer.uint32(18).string(message.synthesis_session_id);
    }
    if (message.contextualization_session_id !== undefined) {
      writer.uint32(26).string(message.contextualization_session_id);
    }
    if (message.slack_chat_session_id !== undefined) {
      writer.uint32(34).string(message.slack_chat_session_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalystRunProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalystRunProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.scenario_chat_sessions.push(AnalystRunProto_ScenarioChatSession.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.synthesis_session_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.contextualization_session_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.slack_chat_session_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalystRunProto {
    return {
      scenario_chat_sessions: globalThis.Array.isArray(object?.scenario_chat_sessions)
        ? object.scenario_chat_sessions.map((e: any) => AnalystRunProto_ScenarioChatSession.fromJSON(e))
        : [],
      synthesis_session_id: isSet(object.synthesis_session_id)
        ? globalThis.String(object.synthesis_session_id)
        : undefined,
      contextualization_session_id: isSet(object.contextualization_session_id)
        ? globalThis.String(object.contextualization_session_id)
        : undefined,
      slack_chat_session_id: isSet(object.slack_chat_session_id)
        ? globalThis.String(object.slack_chat_session_id)
        : undefined,
    };
  },

  toJSON(message: AnalystRunProto): unknown {
    const obj: any = {};
    if (message.scenario_chat_sessions?.length) {
      obj.scenario_chat_sessions = message.scenario_chat_sessions.map((e) =>
        AnalystRunProto_ScenarioChatSession.toJSON(e)
      );
    }
    if (message.synthesis_session_id !== undefined) {
      obj.synthesis_session_id = message.synthesis_session_id;
    }
    if (message.contextualization_session_id !== undefined) {
      obj.contextualization_session_id = message.contextualization_session_id;
    }
    if (message.slack_chat_session_id !== undefined) {
      obj.slack_chat_session_id = message.slack_chat_session_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalystRunProto>, I>>(base?: I): AnalystRunProto {
    return AnalystRunProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalystRunProto>, I>>(object: I): AnalystRunProto {
    const message = createBaseAnalystRunProto();
    message.scenario_chat_sessions =
      object.scenario_chat_sessions?.map((e) => AnalystRunProto_ScenarioChatSession.fromPartial(e)) || [];
    message.synthesis_session_id = object.synthesis_session_id ?? undefined;
    message.contextualization_session_id = object.contextualization_session_id ?? undefined;
    message.slack_chat_session_id = object.slack_chat_session_id ?? undefined;
    return message;
  },
};

function createBaseAnalystRunProto_ScenarioChatSession(): AnalystRunProto_ScenarioChatSession {
  return { scenario_id: undefined, session_id: undefined };
}

export const AnalystRunProto_ScenarioChatSession: MessageFns<AnalystRunProto_ScenarioChatSession> = {
  encode(message: AnalystRunProto_ScenarioChatSession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scenario_id !== undefined) {
      writer.uint32(10).string(message.scenario_id);
    }
    if (message.session_id !== undefined) {
      writer.uint32(18).string(message.session_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalystRunProto_ScenarioChatSession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalystRunProto_ScenarioChatSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.scenario_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.session_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalystRunProto_ScenarioChatSession {
    return {
      scenario_id: isSet(object.scenario_id) ? globalThis.String(object.scenario_id) : undefined,
      session_id: isSet(object.session_id) ? globalThis.String(object.session_id) : undefined,
    };
  },

  toJSON(message: AnalystRunProto_ScenarioChatSession): unknown {
    const obj: any = {};
    if (message.scenario_id !== undefined) {
      obj.scenario_id = message.scenario_id;
    }
    if (message.session_id !== undefined) {
      obj.session_id = message.session_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalystRunProto_ScenarioChatSession>, I>>(
    base?: I,
  ): AnalystRunProto_ScenarioChatSession {
    return AnalystRunProto_ScenarioChatSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalystRunProto_ScenarioChatSession>, I>>(
    object: I,
  ): AnalystRunProto_ScenarioChatSession {
    const message = createBaseAnalystRunProto_ScenarioChatSession();
    message.scenario_id = object.scenario_id ?? undefined;
    message.session_id = object.session_id ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
